export { SpeechIcon } from "./speech";
